import React from 'react';
import Modal from '../../../shared/components/modals/Modal';
import './LoginHealthHelpModal.css';

export default function LoginHealthHelpModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Login health" size="large">
      <div className="login-health-help">
        <p className="login-health-help__lead">
          Metrics below cover authentication activity at <strong>this location</strong> over the
          {' '}<strong>last 7 days</strong>.
        </p>

        <section>
          <h3>Key metrics</h3>
          <ul className="login-health-help__list">
            <li>
              <strong>Failed attempts</strong> — total login failures. More than 5 in 7 days is a
              red flag; review the table below.
            </li>
            <li>
              <strong>Known users affected</strong> — distinct recognized users with at least one
              failed login (excludes unrecognized usernames).
            </li>
            <li>
              <strong>Unknown usernames</strong> — usernames tried that do not match any account;
              shown when identity probing is detected.
            </li>
            <li>
              <strong>Success rate</strong> — successful logins as a share of all attempts.
              Green at 90% or above; below that may indicate auth problems or attacks.
            </li>
          </ul>
        </section>

        <section>
          <h3>Failure reasons</h3>
          <ul className="login-health-help__list">
            <li>
              <strong>Wrong password</strong> — valid user ID but incorrect password (mistake,
              brute force, or possible credential compromise).
            </li>
            <li>
              <strong>User not found</strong> — username or ID does not exist (typo, invalid ID,
              or unauthorized access attempt).
            </li>
            <li>
              <strong>Account inactive</strong> — deactivated user trying to sign in; may need
              re-activation or cleanup.
            </li>
          </ul>
        </section>

        <section>
          <h3>When to act</h3>
          <ul className="login-health-help__list">
            <li>More than 5 failed attempts in 7 days — review affected accounts.</li>
            <li>Success rate below 90% — investigate auth issues or brute-force patterns.</li>
            <li>Many &quot;user not found&quot; rows — check for typos or external probing.</li>
            <li>Click column headers in the failed-logins table to sort (default: last attempt, most recent first).</li>
            <li>Inactive account failures — re-activate users who need access, or leave disabled.</li>
          </ul>
        </section>
      </div>
    </Modal>
  );
}
